import { UpdateProfileRequest } from "../models/update-profile-request";
import { put } from "./utils";

export const updateProfile = async (profile: UpdateProfileRequest) => await put("profile", profile);
